import { OrgAdminConstants } from '../../../_constants';

const initialState = { changeAccessLoading: true, data: '', error: false };

export function changeAccessReducer(state = initialState, action) {

    switch (action.type) {
        case OrgAdminConstants.REQUEST_CHANGE_ACCESS:
            return {
                changeAccessLoading: true,
                data: '',
                error: false
            };
        case OrgAdminConstants.RECEIVE_CHANGE_ACCESS:
            return {
                changeAccessLoading: false,
                data: action.getOrgUser,
                error: false
            };
        case OrgAdminConstants.CHANGE_ACCESS_ERROR:
            return {
                changeAccessLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/OrgAdmin/PaUsers/changeAccess.reducer.js